export enum EQuantityFormatKey {
  PRODUCTS = 'productsQuantityFormat',
  BALANCE = 'balanceQuantityFormat',
  SPECIAL_OFFER = 'specialOfferQuantityFormat',
  ROLLING_OFFER = 'rollingOfferQuantityFormat',
  PROGRESS_BAR = 'progressBarQuantityFormat',
  TRIGGERED_POPUP = 'triggeredPopupQuantityFormat'
}

export enum EQuantityFieldControl {
  SEPARATOR = 'separator',
  BOOLEAN = 'boolean',
  NUMBER = 'number'
}

export interface IQuantityFormat {
  milSeparator: string;
  fractionalSeparator: string;
  thousandShorthand: boolean;
  millionShorthand: boolean;
  billionShorthand: boolean;
  trillionShorthand: boolean;
  quadrillionShorthand: boolean;
  quintillionShorthand: boolean;
  sextillionShorthand: boolean;
  septillionShorthand: boolean;
  digitsBasedAbbreviation: boolean;
  maxDigitsWithoutShorthand: number;
}

export interface IStoreSettingsFormValues {
  productsQuantityFormat: IQuantityFormat;
  balanceQuantityFormat: IQuantityFormat;
  specialOfferQuantityFormat: IQuantityFormat;
  rollingOfferQuantityFormat: IQuantityFormat;
  progressBarQuantityFormat: IQuantityFormat;
  triggeredPopupQuantityFormat: IQuantityFormat;
}

export interface IQuantityFieldDescriptor {
  key: keyof IQuantityFormat;
  header: string;
  control: EQuantityFieldControl;
  gridSize: number;
}

export interface IQuantityFormatSection {
  key: EQuantityFormatKey;
  title: string;
}
